import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router } from "@angular/router";
import { AuthService } from "./auth.service";
import { AppUrlsService } from "./app-urls.service";
import { SharedDataService } from "./shared.service";

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private appUrlsService: AppUrlsService,
    private _SharedService: SharedDataService,
    private router: Router
  ) { }

  isAccessable: boolean = false;
  loopCount: number = 0;

  canActivate(route: ActivatedRouteSnapshot) {
    console.log('here is routeon active.....',route)
    let isAccessable: boolean = false;
    let urlSegments = route['_urlSegment']['segments'];
    console.log('here is routeon urlsegmantas.....',urlSegments)


    if (urlSegments.length == 0) {
      console.log('here is routeon urlsegmantas..lenght....',urlSegments.length)

      this._SharedService.sidebarURLs.forEach(url => {

        if ("dashboard" == url) {
          isAccessable = true;
        }
      });
    } else {
      urlSegments.forEach(urlSegment => {
        if (urlSegment['path'] != '' && urlSegment['path'] != 'video' && urlSegment['path'] != 'user') {

          this._SharedService.sidebarURLs.forEach(url => {

            if (urlSegment['path'] == url) {
              isAccessable = true;
            }
          });
        }
      });
    }

    if (this.authService.isAuthenticated && isAccessable) {
      return true;
    } else if (this.authService.isAuthenticated && !isAccessable && this._SharedService.isSidebarLoaded) {
      this.router.navigate(["/error"]);
      return false;
    }

    this._SharedService.setNavigateURL = urlSegments;
    this.router.navigate(["/sso/login"]);
    return false;
  }
}
